import { TcollectId, TGetCollectIndex, TCollectDataType } from "@/module/collect";
import { TTotal } from "@/module/common";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 添加收藏
export const getAddCollect = (data: TcollectId) => {
    return request<TcollectId, boolean>({
        url: '/api/user/collection/addcollection',
        method: 'POST',
        data
    })
}
// 取消收藏
export const getRemoveCollect = (data: TcollectId) => {
    return request<TcollectId, boolean>({
        url: '/api/user/collection/cancelcollection',
        method: 'POST',
        data
    })
}
// 我的收藏列表
export const getCollectList = (data: TGetCollectIndex) => {
    return request<TGetCollectIndex, TTotal<TCollectDataType>>({
        url: '/api/user/collection/collectionlist',
        method: 'POST',
        data
    })
}

